import { useEffect, useMemo, useState } from "react";
import { FormProvider, useForm, useFieldArray } from "react-hook-form";
import { useNavigate } from "react-router";
import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
import { useCreateEmployeeFloatMutation } from "../../../../api/employeeFloat";
import {
  CTAButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import {
  CheckBox,
  CustomFloatSearchableSelect,
  CustomSearchableSelect,
  FormSelect,
  FormTemplate,
} from "../../../Components/Forms/InputTemplate";
import PageStyle from "../../../Components/Layout/PageLayout";
import {
  GetAllPaymentService,
  GetAllPaymentSubclass,
  GetAllPaymentSubclassComp,
} from "../../../../../utils/redux/Finance/PaymentService/PaymentServiceSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  useGetBudgetDetailsQuery,
  useGetBudgetSummaryQuery,
} from "../../../../api";
import { SearchFilter } from "../../../Components/Search/Search";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import { DotIcon, MinusIcon, PlusIcon } from "@radix-ui/react-icons";
import input from "./input.module.css";
import bin from "../../../assets/bin.svg";
import { GetConsummableAcquisition } from "../../../../../utils/redux/Consumables/ConsumablesSlice";
import { Autocomplete, TextField } from "@mui/material";
import axios from "axios";
import {
  GetCategories,
  GetConsummableClass,
} from "../../../../../utils/redux/ConsummableSetUp/ConsummableSetUpSlice";
import { GetVendors } from "../../../../../utils/redux/Vendor/VendorSlice";
import { getAgentMembers, getTeamMembers } from "../../../../api/epsPlusApi";
const FloatRequestCreate = () => {
  const {
    filter,
    currentPage,
    setFilter,
    setPageSize,
    setCurrentPage,
    find,
    findSearch,
    sort,
    searchText,
    setSearchText,
  } = useSearchFilter({
    initialFilter: 1,
    initialSort: 1,
  });
  const hrRoot = process.env.REACT_APP_BACKEND_HR_URL;
  const token = JSON.parse(localStorage.getItem("user"))?.userToken;
  const currentYear = new Date().getFullYear();
  const [pageSize] = useState(1000);
  const [pageNumber] = useState(1);
  const [departmentValue, setDepartmentValue] = useState();
  const [budgetValue, setBudgetValue] = useState();
  const [newBudgetData, setNewBudgetData] = useState([]);
  const [budgetId, setBudgetId] = useState();
  const [newBudgetId, setNewBudgetId] = useState();
  const [subCategory, setSubCategory] = useState("");
  const [isServices, setIsServices] = useState(false);
  const [subClassId, setSubClassId] = useState();
  const [isFoundData, setIsFouncData] = useState();
  const [quantities, setQuantities] = useState({});
  const [subClassesArray, setSubClassesArray] = useState([]);
  const [teamData, setTeamData] = useState([]);
  const [agentData, setAgentData] = useState([]);
  const { data: budgetDetails } = useGetBudgetDetailsQuery({
    pageSize,
    pageNumber,
    SummaryId: budgetId,
  });
  useEffect(() => {
    const getDepartment = async () => {
      try {
        const res = await axios.get(
          `${hrRoot}/Department/AllDepartment?&PageSize=${pageSize}&PageNumber=1`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (res) {
          setNewBudgetData(res?.data?.responseObject?.pageItems);
        }
      } catch (err) {
        console.log(err);
      }
    };
    getDepartment();
  }, [hrRoot, pageSize, token]);
  // console.log("budgetComponents", budgetComponents);
  const dispatch = useDispatch();
  const { allPaymentSubclassData, allPaymentSubclassCompData } = useSelector(
    (state) => state?.paymentService
  );
  const { acquisition } = useSelector((state) => state?.consumable);
  const apiData = useMemo(
    () => ({
      pageSize: pageSize,
      pageNumber: pageNumber,
    }),
    [pageSize, pageNumber]
  );
  const { category, consummable_class } = useSelector(
    (x) => x?.consummableSetUp
  );

  const { data: budgetSummaryData } = useGetBudgetSummaryQuery({
    pageSize,
    PageNumber: pageNumber,
    Year: currentYear,
  });
  const budgetData = budgetSummaryData?.result ?? [];
  useEffect(() => {
    dispatch(GetAllPaymentService(apiData));
    dispatch(GetAllPaymentSubclass(apiData));
    dispatch(GetAllPaymentSubclassComp(apiData));
    if (subClassId) {
      dispatch(
        GetConsummableAcquisition({
          filter: filter,
          pageSize: pageSize,
          currentPage: currentPage,
          searchText: searchText,
          SortBy: sort,
          SubClassId: subClassId,
        })
      );
    }
    dispatch(
      GetCategories({
        pageSize: 100000,
        currentPage: 1,
        sort: 0,
        filter: 2,
      })
    );
  }, [
    dispatch,
    apiData,
    pageSize,
    currentPage,
    filter,
    find,
    searchText,
    sort,
    subClassId,
  ]);
  const AssetConsumableClassification = {
    Default: 0,
    Goods: 1,
    Services: 2,
  };
  const [onCreate, { isLoading, isError, error }] =
    useCreateEmployeeFloatMutation();
  const navigate = useNavigate();
  const formMethods = useForm({
    mode: "all",
    defaultValues: {
      requestFor: 0,
      purpose: 0,
      floatTypes: [],
      assignedAUM: 0,
      justification: "",
      activityDescription: "",
      expectedOutcome: "",
      floatAdvance: {
        subcategory: "",
        subcategoryId: 0,
        budgetLineId: 0,
        components: [],
      },
      promotionalItems: {
        itemCategory: "",
        itemCategoryId: 0,
        budgetLineId: 0,
        items: [],
      },
      perishableItem: {
        category: "",
        categoryId: 0,
        itemName: "",
        itemId: 0,
        amountRequested: 0,
        vendorId: 0,
        vendorName: "",
        deliveryDate: "",
        budgetLineId: 0,
      },
      beneficiaryIds: [],
      prospects: [],
      retention: {
        locationId: 0,
        teams: [],
      },
    },
  });
  const { register, handleSubmit, watch, setValue, control } = formMethods;
  const {
    fields: prospectFields,
    append: appendProspect,
    remove: removeProspect,
  } = useFieldArray({
    control,
    name: "prospects",
  });
  const watchedValues = watch();
  const components = watch("floatAdvance.components");
  const totalAmount =
    components?.reduce((sum, comp) => sum + (comp?.amount || 0), 0) || 0;
  const [effectiveDate, setEffectiveDate] = useState("");
  const [numberOfDays, setNumberOfDays] = useState("");
  const purposes = [
    { label: "Business Development", value: 0 },
    { label: "Relationship Management", value: 1 },
  ];
  const requestForOptions = [
    { label: "Self", value: 0 },
    { label: "Team", value: 1 },
  ];
  const floatList = [
    {
      label: "Float Advance",
      value: 0,
    },
    {
      label: "Promotional Items",
      value: 1,
    },
    { label: "Perishables", value: 2 },
    {
      label: "Visitation",
      value: 3,
    },
  ];

  const budgetLines =
    budgetSummaryData?.result?.map((item) => ({
      label: `${item.department} ${item.year}`,
      value: item.id,
      total: item.total,
      allocatedAmount: item.allocatedAmount,
      disbursedAmount: item.disbursedAmount,
      actualBudget: item.actualBudget,
    })) || [];
  const user = GetLocalStorage();
  //  const employeeData = data?.responseObject?.employee
  const onSubmit = async (data) => {
    // Build payload using form data
    const payload = {
      ...data,
      prospects: data.prospects.map((p) => ({
        staffId: user.staffId,
        employerId: 0, // From target selection
        employerName: "", // From target
        items: [p],
      })),
    };

    try {
      await onCreate(payload).unwrap();
      navigate(-1);
    } catch (err) {
      console.error("Error creating float request:", err);
    }
  };
  const selectedFloatTypeIds = watch("floatTypes") || [];

  const classNameMap = floatList.reduce((acc, item) => {
    acc[item.value] = item.label;
    return acc;
  }, {});

  const floatAdvanceSubclasses = useMemo(() => {
    const data = allPaymentSubclassData?.result?.filter(
      (item) =>
        selectedFloatTypeIds.includes(0) &&
        item.paymentSetupClassName === "Float Advance"
    );

    return (
      data?.map((item) => ({
        label: item.name,
        value: item.id,
      })) || []
    );
  }, [allPaymentSubclassData, selectedFloatTypeIds]);
  const expenseClaimSubComponents = useMemo(() => {
    const data = acquisition?.result;
    return data || [];
  }, [acquisition?.result]);

  const perishableSubclasses = useMemo(() => {
    const data = allPaymentSubclassData?.result?.filter(
      (item) =>
        selectedFloatTypeIds.includes(item.paymentSetupClassId) &&
        classNameMap[item.paymentSetupClassId] === "Perishables"
    );
    return (
      data?.map((item) => ({
        label: item.name,
        value: item.id,
      })) || []
    );
  }, [allPaymentSubclassData, selectedFloatTypeIds, classNameMap]);

  const floatTypeDefault = floatList.filter((x) =>
    formMethods.getValues("floatTypes")?.includes(x.value)
  );

  const actionButton = (
    <div className="flex space-x-3 items-center">
      <SupportButtons onClick={() => navigate(-1)}>Cancel</SupportButtons>
      <CTAButtons onClick={handleSubmit} disabled={isLoading}>
        {isLoading ? "Submitting..." : "New Request"}
      </CTAButtons>
    </div>
  );

  const purposeWatch = Number.parseInt(watch("purpose"));
  const requestForWatch = Number.parseInt(watch("requestFor"));
  const teamWatch = watch("teamId");
  console.log(teamWatch, "teamWatch");
  useEffect(() => {
    (async () => {
      const teams = await getTeamMembers();
      setTeamData(teams);
    })();
  }, []);
  useEffect(() => {
    (async () => {
      const agents = await getAgentMembers(teamWatch);
      setAgentData(agents);
    })();
  }, [teamWatch]);
  const dummyOption = [
    { label: "Select item", value: "" },
    { label: "General", value: "General" },
    { label: "Finance", value: "Finance" },
    { label: "HR1", value: "HR1" },
    { label: "HR2", value: "HR2" },
    { label: "HR3", value: "HR3" },
    { label: "HR4", value: "HR4" },
    { label: "HR5", value: "HR5" },
    { label: "HR6", value: "HR6" },
    { label: "HR7", value: "HR7" },
    { label: "HR8", value: "HR8" },
    { label: "HR9", value: "HR9" },
    { label: "HR10", value: "HR10" },
    { label: "HR11", value: "HR11" },
    { label: "HR12", value: "HR12" },
  ];
  const agentOptions = agentData?.map((agent) => ({
    label: agent?.newTeam?.teamName,
    value: agent?.newTeam?.id,
  }));
  return (
    <PageStyle
      hasBack={true}
      backURL={`/dashboard/employee/employee-float-request`}
      demoTitle={"NEW FLOAT REQUEST"}
      hasTopPageDemo
      action={actionButton}
    >
      <FormProvider {...formMethods}>
        <FormTemplate handleSubmit={handleSubmit(onSubmit)}>
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold mb-4">
                Request Information
              </h3>
              <div>
                <div className="space-y-6 flex space-x-3 mb-4 items-center">
                  <div className={`${input.input_container} w-1/2`}>
                    <label className={input.input_title}>Purpose *</label>
                    <select
                      {...register("purpose", { valueAsNumber: true })}
                      className={input.input_field}
                    >
                      <option value="">Select Purpose</option>
                      {purposes.map((p) => (
                        <option key={p.value} value={p.value}>
                          {p.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className={`${input.input_container} w-1/2`}>
                    <label className={input.input_title}>Request For *</label>
                    <div className="space-x-2 w-full flex items-center">
                      {requestForOptions.map((r) => (
                        <label key={r.value} className="flex items-center">
                          <input
                            type="radio"
                            value={r.value}
                            {...register("requestFor", { valueAsNumber: true })}
                            className="mr-2"
                            defaultChecked={r.value === 0}
                          />
                          {r.label}
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className={input.input_container}>
                    <label className={input.input_title}>
                      Effective Date *
                    </label>
                    <input
                      type="date"
                      value={effectiveDate}
                      onChange={(e) => setEffectiveDate(e.target.value)}
                      className={input.input_field}
                      placeholder="0"
                    />
                  </div>
                  <div className={input.input_container}>
                    <label className={input.input_title}>
                      Number of Days *
                    </label>
                    <input
                      type="number"
                      value={numberOfDays}
                      onChange={(e) => setNumberOfDays(e.target.value)}
                      className={input.input_field}
                    />
                  </div>
                </div>
              </div>
            </div>
            {purposeWatch === 0 && requestForWatch === 1 && (
              <div>
                <div className="bg-white p-6 rounded-lg shadow">
                  <h3 className="text-lg font-semibold mb-4">
                    Team Information
                  </h3>
                  <div className={input.input_container}>
                    <label className={input.input_title}>Team *</label>
                    <select
                      {...register("teamId", {
                        valueAsNumber: true,
                      })}
                      className={input.input_field}
                    >
                      <option value="">Select item</option>
                      {teamData.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.teamName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <CustomSearchableSelect
                      title={"Staff"}
                      camelCase={`staff`}
                      placeholder={"Select d.."}
                      options={agentOptions}
                      multiple={true}
                      isOptional={false}
                      showCount={true}
                      moreRegister={{
                        onChange: (selectedOptions) => {
                          setValue(`staff`, selectedOptions || []);
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {purposeWatch === 1 && requestForWatch === 1 && (
              <div>
                <div className="bg-white p-6 rounded-lg shadow">
                  <h3 className="text-lg font-semibold mb-4">
                    Team Information
                  </h3>
                  <div className={input.input_container}>
                    <label className={input.input_title}>Team *</label>
                    <select
                      {...register("teamId", {
                        valueAsNumber: true,
                      })}
                      className={input.input_field}
                    >
                      <option value="">Select item</option>
                      {teamData.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.teamName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <SearchFilter
                    value={searchText}
                    text={(searchText) => setSearchText(searchText)}
                    className={"max-w-[300px]"}
                  />
                  <table className="w-full border rounded-md">
                    <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                      <tr>
                        <th className="border p-2">
                          <CheckBox />
                        </th>
                        <th className="border p-2">Staff</th>
                        <th className="border p-2">Assigned AUM</th>
                        <th className="border p-2">NET AUM Position</th>
                        <th className="border p-2">Performance %</th>
                      </tr>
                    </thead>
                    <tbody>
                      {expenseClaimSubComponents
                        .filter((item) =>
                          item.consumable
                            ?.toLowerCase()
                            ?.includes(searchText.toLowerCase())
                        )
                        .map((item, index) => (
                          <tr className="text-[#4B664C] font-[500]" key={index}>
                            <td className="border p-2">
                              <CheckBox />
                            </td>
                            <td className="border p-2">{item?.consumable}</td>
                            <td className="border p-2">{item?.quantityLeft}</td>
                            <td className="border p-2 flex items-center justify-center"></td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold mb-4">Float Information</h3>
              <div>
                <div className="space-y-2">
                  <CustomFloatSearchableSelect
                    title={"Float Type"}
                    camelCase={`floatTypes`}
                    placeholder={"Select float types..."}
                    options={floatList}
                    multiple={true}
                    isOptional={false}
                    defaultValue={floatTypeDefault}
                  />
                </div>
              </div>
            </div>
            {selectedFloatTypeIds.includes(0) && (
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="text-lg font-semibold mb-4">
                  Regular Components (Float Advance)
                </h3>
                <div className="space-y-4">
                  <div className={input.input_container}>
                    <label className={input.input_title}>Sub-Category *</label>
                    <select
                      // {...register("floatAdvance.subcategoryId", {
                      //   valueAsNumber: true,
                      // })}
                      onChange={(e) => setSubCategory(e.target.value)}
                      value={subCategory}
                      className={input.input_field}
                    >
                      <option value="">Select item</option>
                      {floatAdvanceSubclasses.map((s) => (
                        <option key={s.value} value={s.value}>
                          {s.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* Components table - simplified */}
                  <div>
                    <label className="block text-sm font-medium mb-2">
                      Components
                    </label>
                    <table className="w-full border">
                      <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                        <tr>
                          <th className="border p-2">S/N</th>
                          <th className="border p-2">Component</th>
                          <th className="border p-2">Optional</th>
                          <th className="border p-2">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allPaymentSubclassCompData?.result
                          .filter(
                            (item) =>
                              item.paymentSetupSubClassId ===
                              parseInt(subCategory)
                          )
                          ?.map((item, index) => {
                            return (
                              <tr
                                className="text-[#4B664C] font-[500]"
                                key={index}
                              >
                                <td className="border p-2">{index + 1}</td>
                                <td className="border p-2">{item.name}</td>
                                <td className="border p-2">
                                  {item.isEnabled ? "Yes" : "No"}
                                </td>
                                <td className="border p-2">
                                  <div className="border rounded flex items-center space-x-1 p-1 ">
                                    <p>₦</p>
                                    <input
                                      type="number"
                                      {...register(
                                        `floatAdvance.components.${index}.amount`,
                                        {
                                          valueAsNumber: true,
                                        }
                                      )}
                                      className={input.input_field}
                                      placeholder="0.00"
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <div className="bg-[#FCFCFC] p-3 w-full flex justify-end">
                      <div className="flex items-center space-x-2">
                        <p className="text-[#6E9170] text-[12px] font-[400]">
                          Total:
                        </p>
                        <p className="text-[#4B664C]">
                          ₦{totalAmount.toLocaleString()}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className={input.input_container}>
                    <label className={input.input_title}>Department:</label>
                    <Autocomplete
                      disablePortal
                      className={input.input_field}
                      id="combo-box-demo"
                      options={newBudgetData?.map((d, _index) => ({
                        label: d?.name,
                        value: d?.name,
                        id: d?.id,
                        key: _index,
                      }))}
                      getOptionLabel={(option) => option?.label}
                      onChange={(e, newValue) => {
                        // console.log(newValue);
                        setDepartmentValue(newValue?.value || "");
                        // setIsId(newValue?.id || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          // value={departmentValue}
                          placeholder="Choose Department"
                        />
                      )}
                    />
                  </div>
                  <div className="w-full mb-5">
                    <h1 className="text-baseFont text-customGreen mb-2">
                      Budget <span className="text-red-500">*</span>
                    </h1>
                    <Autocomplete
                      disablePortal
                      className={input.input_field}
                      disabled={budgetData?.length < 1}
                      id="combo-box-demo"
                      options={budgetData.map((d, _index) => ({
                        label: `Budget for ${d?.department} for year ${d?.year}`,
                        value: d?.name,
                        id: d?.id,
                        key: _index,
                      }))}
                      getOptionLabel={(option) => option?.label}
                      onChange={(e, newValue) => {
                        setBudgetValue(newValue?.value || "");
                        setBudgetId(newValue?.id || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          value={budgetValue}
                          placeholder={
                            budgetData?.length < 1
                              ? `No budget for ${departmentValue}`
                              : "Choose budget"
                          }
                        />
                      )}
                    />
                  </div>
                  <div className="w-full mb-5">
                    <h1 className="text-baseFont text-customGreen mb-2">
                      Budget Item <span className="text-red-500">*</span>
                    </h1>
                    <Autocomplete
                      disablePortal
                      className={input.input_field}
                      id="combo-box-demo"
                      disabled={!budgetDetails?.result}
                      options={budgetDetails?.result?.map((d, _index) => ({
                        label: d?.item + " - " + d?.description,
                        value: d.item,
                        key: _index,
                        id: d.id,
                        details: d,
                      }))}
                      onChange={(e, newValue) => {
                        // console.log(newValue);
                        setNewBudgetId(newValue?.details || "");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Choose budget item"
                        />
                      )}
                    />
                  </div>
                  {newBudgetId && (
                    <div>
                      <div>
                        <p className="text-[#6E9170] text-[12px] font-[400]">
                          Budget Status
                        </p>
                      </div>
                      <div>
                        <p className="text-[#29382A] text-[12px] font-[400]">
                          ₦{newBudgetId?.total} avaiable of ₦
                          {newBudgetId?.total - newBudgetId?.actualExpenditure}
                        </p>
                      </div>
                    </div>
                  )}
                  {newBudgetId?.actualExpenditure > newBudgetId?.total && (
                    <div className="bg-red-100/95 border-[#B9303080] border-1 p-4 rounded-md">
                      <div>
                        <p className="text-[#29382A]">Budget Status:</p>
                      </div>
                      <div>
                        <p className="text-[#B93030]">
                          Request exceeds budget by ₦
                          {newBudgetId?.actualExpenditure - newBudgetId?.total}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {selectedFloatTypeIds.includes(1) && (
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="text-lg font-semibold mb-4">Promotional Item</h3>
                <div className="space-y-4">
                  <section>
                    <div>
                      <div className={input.input_container}>
                        <FormSelect
                          title={"Consummable Category"}
                          camelCase={"promotionalItems.itemCategoryId"}
                          placeholder={"select"}
                          // isOptional={true}
                          array={category?.result
                            .filter((x) => x.status === "Approved")
                            .map((x, index) => (
                              <option key={index} value={+x?.id}>
                                {x?.categoryName}
                              </option>
                            ))}
                          moreRegister={{
                            onChange: (e) => {
                              console.log("category?.result", category?.result);
                              console.log("e.target.value", e.target.value);

                              // Filter the category result based on the selected value and the AssetConsumableClassification.Services
                              var selectedCategory = category?.result.filter(
                                (x) =>
                                  x.assetConsumableClassification ===
                                    AssetConsumableClassification.Services &&
                                  parseInt(x.id) === parseInt(e.target.value)
                              );

                              console.log("selectedCategory", selectedCategory);

                              // Check if any items match the filter criteria
                              if (selectedCategory.length > 0) {
                                // Check if the selected item's assetConsumableClassification matches AssetConsumableClassification.Services
                                setIsServices(true);
                              } else {
                                // Handle the case when no items match the filter criteria
                                setIsServices(false);
                                console.log(
                                  "No item found matching the filter criteria."
                                );
                              }

                              dispatch(
                                GetConsummableClass({
                                  pageSize: 100000,
                                  currentPage: 1,
                                  sort: 0,
                                  filter: 0,
                                  CategoryId: +e.target.value,
                                })
                              );
                              return null;
                            },
                          }}
                        />
                      </div>
                    </div>
                    <div className="grid items-center gap-4 grid-cols-2">
                      <div>
                        <FormSelect
                          title={"Class"}
                          camelCase={`consumableClassId`}
                          placeholder={"select"}
                          array={consummable_class?.responseObject?.map?.(
                            (x, index) => (
                              <option key={index} value={x?.id}>
                                {x?.name}
                              </option>
                            )
                          )}
                          moreRegister={{
                            onChange: (e) => {
                              const isFound =
                                consummable_class?.responseObject?.find(
                                  (x) => +e.target.value === +x?.id
                                );
                              return setIsFouncData(isFound);
                            },
                          }}
                        />
                      </div>
                      <div>
                        <FormSelect
                          title={"Sub Class"}
                          camelCase={`consumableSubClassId`}
                          placeholder={"select"}
                          array={isFoundData?.categorySubClass?.map?.(
                            (x, index) => (
                              <option key={index} value={x?.id}>
                                {x?.name}
                              </option>
                            )
                          )}
                          moreRegister={{
                            onChange: (e) => setSubClassId(e.target.value),
                          }}
                        />
                      </div>
                    </div>
                  </section>
                  <SearchFilter
                    value={searchText}
                    text={(searchText) => setSearchText(searchText)}
                    className={"max-w-[300px]"}
                  />
                  <table className="w-full border rounded-md">
                    <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                      <tr>
                        <th className="border p-2">SN</th>
                        <th className="border p-2">Item</th>
                        <th className="border p-2">Stock Availability</th>
                        <th className="border p-2">Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {expenseClaimSubComponents
                        .filter((item) =>
                          item.consumable
                            ?.toLowerCase()
                            ?.includes(searchText.toLowerCase())
                        )
                        .map((item, index) => (
                          <tr className="text-[#4B664C] font-[500]" key={index}>
                            <td className="border p-2">{index + 1}</td>
                            <td className="border p-2">{item?.consumable}</td>
                            <td className="border p-2">{item?.quantityLeft}</td>
                            <td className="border p-2 flex items-center justify-center">
                              <div className="flex space-x-2 justify-between items-center">
                                <button
                                  type="button"
                                  className=" rounded-md p-3"
                                  style={{
                                    border: "1px solid #D9E9DA",
                                  }}
                                  onClick={() =>
                                    setQuantities((prev) => ({
                                      ...prev,
                                      [item.id]: Math.max(
                                        0,
                                        (prev[item.id] || 0) - 1
                                      ),
                                    }))
                                  }
                                >
                                  <MinusIcon />
                                </button>
                                <div className="border border-[#D9E9DA] flex justify-center min-w-14 rounded-md py-[9px]">
                                  <p className="text-[12px]">
                                    {quantities[item.id] || 0}
                                  </p>
                                </div>
                                <button
                                  type="button"
                                  className=" rounded-md p-3"
                                  style={{
                                    border: "1px solid #D9E9DA",
                                  }}
                                  onClick={() =>
                                    setQuantities((prev) => ({
                                      ...prev,
                                      [item.id]: Math.min(
                                        item.quantityLeft,
                                        (prev[item.id] || 0) + 1
                                      ),
                                    }))
                                  }
                                >
                                  <PlusIcon />
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  <div className="bg-[#FCFCFC] p-3 w-full flex justify-between flex-wrap">
                    {expenseClaimSubComponents.map((item, index) => (
                      <div key={index} className="flex items-center space-x-2">
                        <p className="text-[#6E9170] text-[12px] font-[400]">
                          {item?.consumable} 20
                        </p>
                        <p className="text-[#4B664C]">
                          <DotIcon className="bg-[#4B664C] rounded-full w-[5px] h-[5px]" />
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {selectedFloatTypeIds.includes(2) && (
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="text-lg font-semibold mb-4">Perishable Item</h3>

                <FormSelect
                  className="col-span-2 sm:col-span-1"
                  title={"Consumable Class"}
                  camelCase={"ConsumableClass"}
                  placeholder={"select"}
                  array={consummable_class?.responseObject
                    ?.filter((x) => {
                      return (
                        x.categorySubClass && x.categorySubClass.length > 0
                      );
                    })
                    ?.map?.((x, index) => (
                      <option key={index} value={x?.id}>
                        {x?.name}
                      </option>
                    ))}
                  moreRegister={{
                    onChange: (e) => {
                      const isFoundData =
                        consummable_class?.responseObject?.find(
                          (x) => +e.target.value === +x?.id
                        );
                      // console.log(1, { isFoundData });
                      // setValue("AssetName", isFoundData?.itemName);
                      setValue("AssetType", isFoundData?.categoryId);
                      setValue("AssetTypeName", isFoundData?.categoryName);
                      setValue("AssetBrand", isFoundData?.assetBrand);
                      setValue("AssetClassName", isFoundData?.name);
                      // setValue(
                      //   "AssetSubClassName",
                      //   isFoundData?.consumableSubClass
                      // );
                      setValue(
                        "Description",
                        isFoundData?.specification
                          ? isFoundData?.specification
                          : isFoundData?.name
                      );
                      setSubClassesArray(
                        isFoundData?.categorySubClass.map((x) => {
                          return {
                            // class: isFoundData.name,
                            ...isFoundData,
                            ...x,
                          };
                        })
                      );
                      // setAssetItems(isFoundData);
                      return;
                    },
                  }}
                />

                <FormSelect
                  className="col-span-2"
                  title={"Consumable Name"}
                  camelCase={"AssetId"}
                  placeholder={"select"}
                  array={subClassesArray?.map?.((x, index) => (
                    <option key={index} value={x?.id}>
                      {x?.name}
                    </option>
                  ))}
                  moreRegister={{
                    onChange: (e) => {
                      const isFoundData = subClassesArray?.find(
                        (x) => +e.target.value === +x?.id
                      );
                      // console.log("isFoundData", isFoundData);
                      // setValue(
                      //   "Description",
                      //   isFoundData?.specification
                      //     ? isFoundData?.specification
                      //     : isFoundData?.name
                      // );
                      setValue("AssetName", isFoundData?.name);
                      // setValue("AssetBrand", isFoundData?.assetBrand);
                      setValue("AssetSubClassName", isFoundData?.name);
                      //  setAssetItems({
                      //    subClassId: isFoundData.id,
                      //    ...isFoundData,
                      //  });
                      dispatch(
                        GetVendors({
                          filter: 2,
                          PageSize: 10000,
                          CurrentPage: 1,
                          sort: 1,
                          SubClass: isFoundData?.id,
                        })
                      );
                      return;
                    },
                  }}
                />

                <div className="grid grid-cols-2 gap-4">
                  <div className={input.input_container}>
                    <label className={input.input_title}>Items</label>
                    <select
                      {...register("perishableItem.categoryId", {
                        valueAsNumber: true,
                      })}
                      className={input.input_field}
                    >
                      <option value="">Select item</option>
                      {perishableSubclasses.map((p) => (
                        <option key={p.value} value={p.value}>
                          {p.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className={input.input_container}>
                    <label className={input.input_title}>Amount</label>
                    <div className="border rounded flex items-center space-x-1 p-1 ">
                      <p>₦</p>
                      <input
                        type="number"
                        {...register("perishableItem.amountRequested", {
                          valueAsNumber: true,
                        })}
                        className={input.input_field}
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                  <div className={input.input_container}>
                    <label className={input.input_title}>Delivery Date</label>
                    <input
                      type="date"
                      {...register("perishableItem.deliveryDate")}
                      className={input.input_field}
                    />
                  </div>
                  <div className={input.input_container}>
                    <label className="block text-sm font-medium mb-1">
                      Budget
                    </label>
                    <select
                      {...register("perishableItem.budgetLineId", {
                        valueAsNumber: true,
                      })}
                      className={input.input_field}
                    >
                      {budgetLines.map((b) => (
                        <option key={b.value} value={b.value}>
                          {b.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )}
            {selectedFloatTypeIds.includes(3) && (
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="text-lg font-semibold mb-4">Visitation</h3>
                <div className="space-y-4">
                  <div className={input.input_container}>
                    <label className={input.input_title}>
                      Activity Description
                    </label>
                    <textarea
                      className={input.input_field}
                      {...register("activityDescription")}
                      rows={3}
                    />
                  </div>
                  <div className={input.input_container}>
                    <label className={input.input_title}>
                      Expected Outcome
                    </label>
                    <textarea
                      {...register("expectedOutcome")}
                      className={input.input_field}
                      rows={3}
                    />
                  </div>
                </div>
              </div>
            )}
            {purposeWatch === 0 && requestForWatch === 0 && (
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="text-lg font-semibold mb-4">
                  Target and Prospect Information
                </h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium mb-1">
                      Target (Employer)
                    </label>
                    <select className="w-full p-2 border rounded">
                      {/* Mock employers */}
                      <option>Dangote Industries</option>
                    </select>
                  </div>
                  {/* Prospects table - simplified */}
                  <table className="w-full border rounded-md">
                    <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                      <tr>
                        <th className="border p-2">Name</th>
                        <th className="border p-2">Email</th>
                        <th className="border p-2">Phone</th>
                        <th className="border p-2">Expected Reg Date</th>
                        <th className="border p-2">Expected AUM</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {prospectFields.map((field, index) => (
                        <tr key={field.id}>
                          <td className="border p-2">
                            <input
                              type="text"
                              {...register(`prospects.${index}.fullName`)}
                              className={input.input_field}
                              placeholder="John Doe"
                            />
                          </td>
                          <td className="border p-2">
                            <input
                              type="email"
                              {...register(`prospects.${index}.email`)}
                              className={input.input_field}
                              placeholder="johndoe@mail.com"
                            />
                          </td>
                          <td className="border p-2">
                            <input
                              type="text"
                              {...register(`prospects.${index}.phoneNumber`)}
                              className={input.input_field}
                              placeholder="08012345678"
                            />
                          </td>
                          <td className="border p-2">
                            <input
                              type="date"
                              {...register(
                                `prospects.${index}.expectedRegistrationDate`
                              )}
                              className={input.input_field}
                            />
                          </td>
                          <td className="border p-2">
                            <div className="border rounded flex items-center space-x-1 p-1 ">
                              <p>₦</p>
                              <input
                                type="number"
                                {...register(`prospects.${index}.expectedAUM`, {
                                  valueAsNumber: true,
                                })}
                                className={input.input_field}
                                placeholder="0.00"
                              />
                            </div>
                          </td>
                          <td>
                            <button
                              type="button"
                              onClick={() => removeProspect(index)}
                              className="bg-[#4B664C] px-1 py-2 mx-3 rounded-md"
                            >
                              <img src={bin} alt="Delete" className="w-4 h-5" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button
                    type="button"
                    onClick={() =>
                      appendProspect({
                        fullName: "",
                        email: "",
                        phoneNumber: "",
                        expectedRegistrationDate: "",
                        expectedAUM: 0,
                      })
                    }
                    style={{
                      border: "1px solid #4B664C",
                    }}
                    className=" text-[#4B664C] px-4 py-2 rounded-md flex items-center space-x-2"
                  >
                    <PlusIcon /> <span>Add More Prospects</span>
                  </button>
                </div>
              </div>
            )}
            {purposeWatch === 0 && requestForWatch === 1 && (
              <div className="bg-white p-6 rounded-lg shadow">
                <h3 className="text-lg font-semibold mb-4">
                  Target Information
                </h3>
                <div className={input.input_container}>
                  <label className={input.input_title}>Location *</label>
                  <select
                    // {...register("floatAdvance.subcategoryId", {
                    //   valueAsNumber: true,
                    // })}
                    onChange={(e) => setSubCategory(e.target.value)}
                    value={subCategory}
                    className={input.input_field}
                  >
                    <option value="">Select item</option>
                    {floatAdvanceSubclasses.map((s) => (
                      <option key={s.value} value={s.value}>
                        {s.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <CustomSearchableSelect
                    title={"Employer"}
                    camelCase={`employer`}
                    placeholder={"Select d.."}
                    options={dummyOption}
                    multiple={true}
                    isOptional={false}
                    showCount={true}
                    moreRegister={{
                      onChange: (selectedOptions) => {
                        // setValue(
                        //   `appriasalObjectives[${index}].selectedDepartments`,
                        //   selectedOptions || []
                        // );
                      },
                    }}
                  />
                </div>
              </div>
            )}
            {/* Justification */}
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold mb-4">
                Detailed Justification
              </h3>
              <textarea
                {...register("justification")}
                className={input.input_field}
                rows={4}
                placeholder="Detailed Justification"
              />
            </div>
            {/* Assigned AUM */}
            <div className="bg-white p-6 rounded-lg shadow">
              <p className="text-sm">
                <strong>Assigned AUM:</strong> ₦
                {watchedValues.assignedAUM.toLocaleString()}
              </p>
            </div>
            {isError && (
              <div className="bg-red-100 p-4 rounded">
                <p className="text-red-700">
                  Error: {error?.data?.message || "Something went wrong"}
                </p>
              </div>
            )}
          </div>
        </FormTemplate>
      </FormProvider>
    </PageStyle>
  );
};

export default FloatRequestCreate;

// take reference from this JSON structure to create the form fields
// {
//   "requestFor": 0,
//   "purpose": 0,
//   "floatTypes": [
//     0
//   ],
//   "assignedAUM": 0,
//   "justification": "string",
//   "activityDescription": "string",
//   "expectedOutcome": "string",
//   "floatAdvance": {
//     "subcategory": "string",
//     "subcategoryId": 0,
//     "budgetLineId": 0,
//     "components": [
//       {
//         "componentName": "string",
//         "componentId": 0,
//         "isCompulsory": true,
//         "amount": 0.01
//       }
//     ]
//   },
//   "promotionalItems": {
//     "itemCategory": "string",
//     "itemCategoryId": 0,
//     "budgetLineId": 0,
//     "items": [
//       {
//         "itemName": "string",
//         "itemId": 0,
//         "quantity": 2147483647
//       }
//     ]
//   },
//   "perishableItem": {
//     "category": "string",
//     "categoryId": 0,
//     "itemName": "string",
//     "itemId": 0,
//     "amountRequested": 0.01,
//     "vendorId": 0,
//     "vendorName": "string",
//     "deliveryDate": "2025-12-10T14:44:46.339Z",
//     "budgetLineId": 0
//   },
//   "beneficiaryIds": [
//     0
//   ],
//   "prospects": [
//     {
//       "staffId": 0,
//       "employerId": 0,
//       "employerName": "string",
//       "items": [
//         {
//           "fullName": "string",
//           "phoneNumber": "string",
//           "email": "user@example.com",
//           "expectedRegistrationDate": "2025-12-10T14:44:46.339Z",
//           "expectedAUM": 10000
//         }
//       ]
//     }
//   ],
//   "retention": {
//     "locationId": 0,
//     "teams": [
//       {
//         "staffId": 0,
//         "employerIds": [
//           0
//         ]
//       }
//     ]
//   }
// }
